// A callback with a stable identity that always runs the latest closure.
// The shell's <Dialog> re-runs its focus effect whenever `onClose` changes
// identity (it restores focus to the previous element and refocuses the
// box), so an inline `onClose` steals focus from a field after every
// keystroke — every Dialog `onClose` here goes through this
// (SHARED-REQUESTS: Dialog should keep onClose in a ref).

import { useCallback, useRef } from 'react';

export function useStableCallback<A extends unknown[], R>(fn: (...args: A) => R): (...args: A) => R {
  const ref = useRef(fn);
  ref.current = fn;
  return useCallback((...args: A) => ref.current(...args), []);
}
